import { BlogPost } from "@models";
import { blogService } from "@services";
import { makeAutoObservable, runInAction } from "mobx";

// TODO: Remove mock data once backend Blog API is implemented
const MOCK_POSTS: BlogPost[] = [
  {
    id: 1,
    title: "Kako izabrati pravog frizera za vas",
    slug: "kako-izabrati-pravog-frizera",
    excerpt:
      "Pronalaženje idealnog frizera može biti izazov. U ovom članku delimo savete koji će vam pomoći da napravite pravi izbor — od provere recenzija do prvog termina.",
    content: `
      <h2>Zašto je važan izbor frizera?</h2>
      <p>Vaša frizura je jedan od prvih utisaka koji ostavljate na ljude. Dobar frizer ne samo da razume vašu kosu, već i vaš stil i način života. Zato je važno da odvojite malo vremena i pronađete nekoga ko zaista odgovara vašim potrebama.</p>

      <h2>1. Proverite recenzije i ocene</h2>
      <p>Pre nego što zakažete termin, pogledajte šta drugi klijenti kažu. Na platformi Rasporedi Me možete videti prosečnu ocenu i pročitati komentare za svakog frizera. Obratite pažnju na komentare koji opisuju sličan tip kose ili frizure koju vi želite.</p>

      <h2>2. Pogledajte portfolio</h2>
      <p>Mnogi frizeri dele svoje radove na Instagramu ili Facebooku. Pogledajte njihov profil na Rasporedi Me gde možete pronaći linkove ka društvenim mrežama i videti primere njihovog rada.</p>

      <h2>3. Zakazite konsultaciju</h2>
      <p>Ne morate odmah ići na veliko šišanje. Zakažite prvi termin za jednostavniju uslugu — trimovanje ili stilizovanje. To je odlična prilika da upoznate frizera i vidite kako radi.</p>

      <h2>4. Komunikacija je ključ</h2>
      <p>Dobar frizer će vas saslušati i dati vam iskreno mišljenje. Ako frizer odmah razume šta želite i predlaže rešenja prilagođena vašoj kosi — to je dobar znak.</p>

      <h2>5. Lokacija i dostupnost</h2>
      <p>Praktičnost je bitna. Izaberite salon koji je blizu vašeg doma ili posla. Na Rasporedi Me možete filtrirati po gradu i brzo pronaći salone u vašoj blizini.</p>

      <blockquote>Savršen frizer nije onaj koji je najskuplji — već onaj koji vas razume.</blockquote>

      <p>Spremni ste da pronađete svog frizera? Pregledajte ponudu na Rasporedi Me i zakažite termin već danas!</p>
    `,
    coverImage: "",
    authorName: "Rasporedi Me",
    categoryKey: "hair",
    tags: ["frizeri", "saveti", "kosa"],
    publishedAt: "2026-03-25T10:00:00",
    creationTime: "2026-03-25T10:00:00",
  },
  {
    id: 2,
    title: "5 trendova u manikiru za 2026. godinu",
    slug: "trendovi-manikir-2026",
    excerpt:
      "Od minimalističkih dizajna do bold boja — otkrijte koji su trendovi u manikiru dominantni ove godine i kako ih možete isprobati u salonu blizu vas.",
    content: `
      <h2>Manikir trendovi koji dominiraju 2026.</h2>
      <p>Ove godine je sve o izrazu ličnosti kroz nokte. Bez obzira da li preferirate diskretan ili upečatljiv stil, ovde ćete pronaći inspiraciju.</p>

      <h2>1. Glazed donut nokti</h2>
      <p>Trend koji je došao da ostane. Svetlucavi, biserasti završetak koji izgleda elegantno na svakoj dužini noktiju. Savršen za one koji vole sofisticiran izgled.</p>

      <h2>2. Bold jednobojni nokti</h2>
      <p>Crvena, plava, zelena — jake, zasićene boje su ponovo in. Jednostavno ali upečatljivo. Jedan sloj gel laka u bold nijansi i spremni ste.</p>

      <h2>3. Micro French</h2>
      <p>Klasični French manikir dobija moderan twist — tanja linija, pastelne boje umesto čisto bele, i ponekad zakrivljeni oblik. Idealan za svakodnevni izgled.</p>

      <h2>4. 3D ukrasi</h2>
      <p>Za one koji vole da se istaknu — mali cvetovi, biseri i geometrijski oblici na noktima. Ovaj trend zahteva iskusnog majstora, pa obratite pažnju na recenzije.</p>

      <h2>5. Negative space dizajn</h2>
      <p>Kombinacija lakiranog i nelakiranog dela nokta stvara moderan, umetnički efekat. Minimalistički ali privlači pažnju.</p>

      <p>Želite da isprobate neki od ovih trendova? Na Rasporedi Me možete pronaći salone za manikir u vašem gradu i zakazati termin online!</p>
    `,
    coverImage: "",
    authorName: "Rasporedi Me",
    categoryKey: "nails",
    tags: ["nokti", "trendovi", "manikir"],
    publishedAt: "2026-03-20T14:00:00",
    creationTime: "2026-03-20T14:00:00",
  },
  {
    id: 3,
    title: "Zašto je redovan odlazak kod stomatologa važan",
    slug: "redovan-odlazak-kod-stomatologa",
    excerpt:
      "Mnogi od nas odlažu posetu stomatologu dok ne osete bol. Saznajte zašto su redovni pregledi ključni za zdravlje zuba i kako da zakažete termin bez stresa.",
    content: `
      <h2>Prevencija je bolja od lečenja</h2>
      <p>Redovni stomatološki pregledi — idealno svakih 6 meseci — mogu sprečiti ozbiljne probleme pre nego što nastanu. Rano otkrivanje karijesa, parodontoze ili drugih problema znači lakše, brže i jeftinije lečenje.</p>

      <h2>Profesionalno čišćenje zuba</h2>
      <p>Koliko god redovno peremo zube, zubni kamenac se vremenom nakuplja. Profesionalno čišćenje uklanja naslage koje četkica ne može, čime se smanjuje rizik od upale desni.</p>

      <h2>Rano otkrivanje problema</h2>
      <p>Stomatolog može uočiti rane znake problema koje vi ne možete videti — od skrivenih karijesa do promena na sluzokoži. Rani tretman je uvek jednostavniji.</p>

      <h2>Saveti za prevazilaženje straha</h2>
      <ul>
        <li>Izaberite stomatologa sa dobrim recenzijama — poverenje je ključno</li>
        <li>Zakažite jutarnji termin kada ste odmorniji</li>
        <li>Recite stomatologu da se plašite — dobar stručnjak će prilagoditi pristup</li>
        <li>Počnite sa pregledom, ne sa intervencijom</li>
      </ul>

      <p>Na Rasporedi Me možete pronaći stomatologe u vašem gradu, pročitati recenzije drugih pacijenata i zakazati termin online — brzo i bez stresa.</p>
    `,
    coverImage: "",
    authorName: "Rasporedi Me",
    categoryKey: "stomatology",
    tags: ["stomatologija", "zdravlje", "prevencija"],
    publishedAt: "2026-03-15T09:00:00",
    creationTime: "2026-03-15T09:00:00",
  },
  {
    id: 4,
    title: "Kako pripremiti kožu pre tretmana šminke",
    slug: "priprema-koze-pre-sminke",
    excerpt:
      "Profesionalna šminka izgleda najbolje na pripremljenom licu. Evo koraka koje možete preduzeti pre odlaska u salon za besprekoran rezultat.",
    content: `
      <h2>Priprema je pola posla</h2>
      <p>Čak i najbolji makeup artist ne može postići savršen rezultat na nepripremljenom licu. Nekoliko jednostavnih koraka dan pre i ujutru pre tretmana mogu napraviti ogromnu razliku.</p>

      <h2>Dan pre tretmana</h2>
      <ul>
        <li><strong>Hidracija</strong> — pijte dovoljno vode i nanesite dobru hidratantnu kremu uveče</li>
        <li><strong>Eksfolijacija</strong> — nežno piling lica uklanja mrtve ćelije i stvara glatku podlogu</li>
        <li><strong>Izbegavajte nove proizvode</strong> — ne eksperimentišite sa novom kozmetikom pre važnog dana</li>
      </ul>

      <h2>Ujutru pre tretmana</h2>
      <ul>
        <li>Operite lice blagim sredstvom za čišćenje</li>
        <li>Nanesite laganu hidratantnu kremu</li>
        <li>Stavite SPF zaštitu ako idete napolje pre tretmana</li>
        <li>Nemojte nanositi prajmer ili puder — to će uraditi makeup artist</li>
      </ul>

      <h2>Šta poneti sa sobom</h2>
      <p>Ako imate inspiraciju (slike sa Pinteresta ili Instagrama), pokažite je makeup artistu. To pomaže da oboje budete na istoj strani i dobijete tačno ono što želite.</p>

      <p>Pronađite iskusne kozmetičare na Rasporedi Me i zakažite termin za profesionalnu šminku!</p>
    `,
    coverImage: "",
    authorName: "Rasporedi Me",
    categoryKey: "makeup",
    tags: ["šminka", "koža", "priprema"],
    publishedAt: "2026-03-10T11:00:00",
    creationTime: "2026-03-10T11:00:00",
  },
  {
    id: 5,
    title: "Online zakazivanje termina: budućnost je stigla",
    slug: "online-zakazivanje-buducnost",
    excerpt:
      "Zašto sve više ljudi bira online zakazivanje umesto poziva? Otkrijte prednosti digitalnog zakazivanja i kako Rasporedi Me olakšava ceo proces.",
    content: `
      <h2>Kraj čekanja na liniji</h2>
      <p>Svi smo bili u situaciji — zovete salon, niko se ne javlja, pa pokušavate ponovo. Ili se javlja zauzet ton. Sa online zakazivanjem, taj problem jednostavno ne postoji.</p>

      <h2>Prednosti online zakazivanja</h2>
      <ul>
        <li><strong>Dostupno 24/7</strong> — zakažite termin u ponoć, rano ujutru ili tokom pauze na poslu</li>
        <li><strong>Vidite sve slobodne termine</strong> — birate tačno vreme koje vam odgovara</li>
        <li><strong>Poređenje salona</strong> — pregledajte ocene, cene i usluge pre zakazivanja</li>
        <li><strong>Podsetnici</strong> — nema više zaboravljenih termina</li>
        <li><strong>Bez pritiska</strong> — birate u miru, bez žurbe telefonskog razgovora</li>
      </ul>

      <h2>Kako funkcioniše Rasporedi Me?</h2>
      <p>Proces je jednostavan:</p>
      <ol>
        <li>Izaberite kategoriju usluge (frizer, kozmetičar, nokti...)</li>
        <li>Pronađite salon u vašem gradu</li>
        <li>Izaberite uslugu, datum i vreme</li>
        <li>Potvrdite — i to je to!</li>
      </ol>

      <p>Ceo proces traje manje od minut. Probajte sami — posetite Rasporedi Me i zakažite svoj prvi termin online!</p>
    `,
    coverImage: "",
    authorName: "Rasporedi Me",
    categoryKey: null,
    tags: ["zakazivanje", "online", "platforma"],
    publishedAt: "2026-03-05T08:00:00",
    creationTime: "2026-03-05T08:00:00",
  },
  {
    id: 6,
    title: "Vodič za izbor masaže: koja je prava za vas?",
    slug: "vodic-za-izbor-masaze",
    excerpt:
      "Relax, sportska, anticelulit ili terapeutska? Svaka masaža ima svoju namenu. Saznajte koja vrsta masaže vam najviše odgovara.",
    content: `
      <h2>Nije svaka masaža ista</h2>
      <p>Masaža je mnogo više od opuštanja. Prava vrsta masaže može ublažiti bol, poboljšati cirkulaciju, smanjiti stres i pomoći u oporavku. Ali kako znati koja je prava za vas?</p>

      <h2>Relax masaža</h2>
      <p>Idealna za oslobađanje svakodnevnog stresa. Koristi lagane, dugačke pokrete koji opuštaju mišiće i smiruju um. Savršena ako vam treba pauza od hektičnog tempa.</p>

      <h2>Sportska masaža</h2>
      <p>Namenjena aktivnim ljudima i sportistima. Fokusira se na mišićne grupe koje su pod stresom od treninga. Intenzivnija je od relax masaže, ali efekat je odličan za oporavak.</p>

      <h2>Anticelulit masaža</h2>
      <p>Kombinuje duboke pokrete i specijalne tehnike za poboljšanje cirkulacije i smanjenje celulita. Redovni tretmani daju najbolje rezultate.</p>

      <h2>Terapeutska masaža</h2>
      <p>Za hronične bolove u leđima, vratu ili ramenima. Terapeut se fokusira na problematične zone i koristi duboke tehnike za dugoročno olakšanje.</p>

      <blockquote>Ako niste sigurni koja masaža vam treba, recite terapeutu simptome — oni će preporučiti pravu vrstu.</blockquote>

      <p>Pronađite masere u vašem gradu na Rasporedi Me i zakažite termin za masažu koja vam je potrebna!</p>
    `,
    coverImage: "",
    authorName: "Rasporedi Me",
    categoryKey: "massage",
    tags: ["masaža", "zdravlje", "opuštanje"],
    publishedAt: "2026-03-01T12:00:00",
    creationTime: "2026-03-01T12:00:00",
  },
];

const USE_MOCK = true; // TODO: Set to false when backend Blog API is ready

export default class BlogStore {
  posts: BlogPost[] = [];
  post: BlogPost | undefined = undefined;
  totalCount = 0;
  skipCount = 0;
  maxResultCount = 9;
  loading = false;

  constructor() {
    makeAutoObservable(this);
  }

  getAll = async (tag?: string, categoryKey?: string) => {
    this.loading = true;
    if (USE_MOCK) {
      runInAction(() => {
        let filtered = MOCK_POSTS;
        if (tag) filtered = filtered.filter((p) => p.tags.includes(tag));
        if (categoryKey) filtered = filtered.filter((p) => p.categoryKey === categoryKey);
        this.posts = filtered;
        this.totalCount = filtered.length;
        this.loading = false;
      });
      return;
    }
    try {
      const response = await blogService.getAll({
        maxResultCount: this.maxResultCount,
        skipCount: this.skipCount,
        tag,
        categoryKey,
      });
      runInAction(() => {
        this.posts = this.skipCount === 0
          ? response.items
          : [...this.posts, ...response.items];
        this.totalCount = response.totalCount;
        this.loading = false;
      });
    } catch (error) {
      console.error(error);
      runInAction(() => { this.loading = false; });
    }
  };

  getBySlug = async (slug: string) => {
    this.loading = true;
    if (USE_MOCK) {
      runInAction(() => {
        this.post = MOCK_POSTS.find((p) => p.slug === slug);
        this.loading = false;
      });
      return;
    }
    try {
      const response = await blogService.getBySlug(slug);
      runInAction(() => {
        this.post = response;
        this.loading = false;
      });
    } catch (error) {
      console.error(error);
      runInAction(() => { this.loading = false; });
    }
  };

  loadMore = () => {
    this.skipCount += this.maxResultCount;
  };

  get hasMore() {
    return this.posts.length < this.totalCount;
  }

  clear = () => {
    this.posts = [];
    this.post = undefined;
    this.totalCount = 0;
    this.skipCount = 0;
  };
}
